"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { JSEncrypt } from 'jsencrypt'
var _default = exports.default = {
  name: 'Login',
  data: function data() {
    return {
      loading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    handleLogin: function handleLogin() {
      window.location.href = process.env.VUE_APP_BASE_API_CORE + 'saml/ssoLogin';
      // this.$api.login.jumpSSO()
    }
  }
};